var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"events"},[_c('van-tabs',{staticClass:"eventtab",model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('van-tab',{attrs:{"title":_vm.$t('common.p5'),"name":"festival"}},[_c('festival')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }